import React from "react";
var BulletSvg = function BulletSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "5",
    cy: "5",
    r: "4.792",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
BulletSvg.defaultProps = {
  width: "10",
  height: "10",
  viewBox: "0 0 10 10",
  xmlns: "http://www.w3.org/2000/svg"
};
var ChevronDownSvg = function ChevronDownSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "21.999023 6.58578644 23.4132366 8 11.9995115 19.4137251 0.585786438 8 2 6.58578644 11.999 16.585"
  })));
};
ChevronDownSvg.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var ChevronLeftSvg = function ChevronLeftSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "17.4134808 21.9992673 15.9992673 23.4134808 4.58554219 11.9997558 15.9992673 0.586030688 17.4134808 2.00024425 7.41426725 11.9992443"
  })));
};
ChevronLeftSvg.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var ChevronRightSvg = function ChevronRightSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "6.58554219 2.00024425 7.99975575 0.586030688 19.4134808 11.9997558 7.99975575 23.4134808 6.58554219 21.9992673 16.5847557 12.0002673"
  })));
};
ChevronRightSvg.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var ChevronUpSvg = function ChevronUpSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "2 17.4137251 0.585786438 15.9995115 11.9995115 4.58578644 23.4132366 15.9995115 21.999023 17.4137251 12.000023 7.4145115"
  })));
};
ChevronUpSvg.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var CloseSvg = function CloseSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,0.585786438 L23.4142136,2 L13.4137864,11.9997864 L23.4142136,22 L22,23.4142136 L11.9997864,13.4137864 L2,23.4142136 L0.585786438,22 L10.5857864,11.9997864 L0.585786438,2 L2,0.585786438 L11.9997864,10.5857864 L22,0.585786438 Z",
    fill: "currentColor"
  })));
};
CloseSvg.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var HomeSvg = function HomeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,21.9997864 L14,15 L10,15 L10,21.9997864 L2,22 L2,12.4142136 C2,11.9427176 2.16648982,11.4883872 2.46691315,11.1298202 L2.58578644,11 L12,1.58578644 L21.4142136,11 C21.7476116,11.333398 21.9511456,11.7723842 21.9922594,12.2383607 L22,12.4142136 L22,22 L14,21.9997864 Z M12,4.414 L4,12.4142136 L4,20 L8,19.9997864 L8,15 C8,13.9456382 8.81587779,13.0818349 9.85073766,13.0054857 L10,13 L14,13 C15.0543618,13 15.9181651,13.8158778 15.9945143,14.8507377 L16,15 L16,19.9997864 L20,20 L20,12.4142136 L12,4.414 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })));
};
HomeSvg.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var InformationSvg = function InformationSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 Z M12,2.83333333 C6.93738979,2.83333333 2.83333333,6.93738979 2.83333333,12 C2.83333333,17.0626102 6.93738979,21.1666667 12,21.1666667 C17.0626102,21.1666667 21.1666667,17.0626102 21.1666667,12 C21.1666667,6.93738979 17.0626102,2.83333333 12,2.83333333 Z M13,10 L13,18 L11,18 L11,10 L13,10 Z M12,6 C12.5128358,6 12.9355072,6.38272018 12.9932723,6.88266744 L13,7 C13,7.51283584 12.6172798,7.93550716 12.1173326,7.99327227 L12,8 C11.4477153,8 11,7.55613518 11,7 C11,6.48716416 11.3827202,6.06449284 11.8826674,6.00672773 L12,6 Z",
    fill: "currentColor"
  })));
};
InformationSvg.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var MenuSvg = function MenuSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,18 L22,20 L2,20 L2,18 L22,18 Z M22,11 L22,13 L2,13 L2,11 L22,11 Z M22,4 L22,6 L2,6 L2,4 L22,4 Z",
    fill: "currentColor"
  })));
};
MenuSvg.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var MinusSvg = function MinusSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "24 11 24 13 0 13 0 11"
  })));
};
MinusSvg.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var NegativeSvg = function NegativeSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 Z M12,2.83333333 C6.93738979,2.83333333 2.83333333,6.93738979 2.83333333,12 C2.83333333,17.0626102 6.93738979,21.1666667 12,21.1666667 C17.0626102,21.1666667 21.1666667,17.0626102 21.1666667,12 C21.1666667,6.93738979 17.0626102,2.83333333 12,2.83333333 Z M12,16 C12.5128358,16 12.9355072,16.3827202 12.9932723,16.8826674 L13,17 C13,17.5128358 12.6172798,17.9355072 12.1173326,17.9932723 L12,18 C11.4871642,18 11.0644928,17.6172798 11.0067277,17.1173326 L11,17 C11,16.4871642 11.3827202,16.0644928 11.8826674,16.0067277 L12,16 Z M13,6 L13,14 L11,14 L11,6 L13,6 Z",
    fill: "currentColor"
  })));
};
NegativeSvg.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var PadlockSvg = function PadlockSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,11 L16,7 C16,4.85780461 14.3160315,3.10892112 12.1996403,3.00489531 L12,3 C9.85780461,3 8.10892112,4.68396847 8.00489531,6.80035966 L8,7 L8,11 L16,11 Z M18,13 L6,13 L6,21 L18,21 L18,13 Z M12,16 C12.5522847,16 13,16.4477153 13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 C11,16.4477153 11.4477153,16 12,16 Z M6,7 C6,3.6862915 8.6862915,1 12,1 C15.2383969,1 17.8775718,3.56557489 17.9958615,6.77506174 L18,7 L18,11 L18.1492623,11.0054857 C19.1841222,11.0818349 20,11.9456382 20,13 L20,13 L20,21 C20,22.1045695 19.1045695,23 18,23 L18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,21 L4,13 C4,11.8954305 4.8954305,11 6,11 L6,11 L6,7 Z",
    fill: "currentColor"
  })));
};
PadlockSvg.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var PlusSvg = function PlusSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13,0 L13,11 L24,11 L24,13 L13,13 L13,24 L11,24 L11,13 L0,13 L0,11 L11,11 L11,0 L13,0 Z",
    fill: "currentColor"
  })));
};
PlusSvg.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var PositiveSvg = function PositiveSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,1 C5.92486775,1 1,5.92486775 1,12 C1,18.0751322 5.92486775,23 12,23 C18.0751322,23 23,18.0751322 23,12 C23,5.92486775 18.0751322,1 12,1 Z M12,2.83333333 C17.0626102,2.83333333 21.1666667,6.93738979 21.1666667,12 C21.1666667,17.0626102 17.0626102,21.1666667 12,21.1666667 C6.93738979,21.1666667 2.83333333,17.0626102 2.83333333,12 C2.83333333,6.93738979 6.93738979,2.83333333 12,2.83333333 Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    fillRule: "nonzero",
    points: "17 7 18.4358008 8.39229167 8.99062767 18.1326265 5 14.0172917 6.43580079 12.625 8.98990039 15.2591458"
  })));
};
PositiveSvg.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var SearchSvg = function SearchSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10,1 C14.9705627,1 19,5.02943725 19,10 C19,12.124779 18.2636898,14.0775836 17.0323074,15.6171757 L22.7781746,21.363961 L21.363961,22.7781746 L15.6171757,17.0323074 C14.0775836,18.2636898 12.124779,19 10,19 C5.02943725,19 1,14.9705627 1,10 C1,5.02943725 5.02943725,1 10,1 Z M10,3 C6.13400675,3 3,6.13400675 3,10 C3,13.8659932 6.13400675,17 10,17 C13.8659932,17 17,13.8659932 17,10 C17,6.13400675 13.8659932,3 10,3 Z",
    fill: "currentColor"
  })));
};
SearchSvg.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var TickSvg = function TickSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "currentColor",
    points: "22.2928932 3.29289322 23.7071068 4.70710678 7 21.4142136 0.292893219 14.7071068 1.70710678 13.2928932 7 18.585"
  })));
};
TickSvg.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var WarningSvg = function WarningSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2952567,2.08976805 C10.8130288,1.07222106 11.9959246,0.701022889 12.9373283,1.26067373 C13.2605701,1.45283627 13.5265984,1.74038162 13.7043814,2.08976805 L13.7043814,2.08976805 L22.7588325,19.8839481 C23.2766046,20.9014951 22.9331833,22.1800666 21.9917795,22.7397174 C21.7045557,22.9104678 21.3820705,23 21.0542702,23 L21.0542702,23 L2.94536792,23 C1.87097088,23 1,22.0585827 1,20.8972856 C1,20.542972 1.0828325,20.1944033 1.2408056,19.8839481 L1.2408056,19.8839481 Z M12.0022278,3 L2.9956665,21.0060577 L21.0027924,20.9994812 L12.0022278,3 Z M12,17 C12.5128358,17 12.9355072,17.3827202 12.9932723,17.8826674 L13,18 C13,18.5128358 12.6172798,18.9355072 12.1173326,18.9932723 L12,19 C11.4477153,19 11,18.5561352 11,18 C11,17.4871642 11.3827202,17.0644928 11.8826674,17.0067277 L12,17 Z M13,9 L13,15 L11,15 L11,9 L13,9 Z",
    fill: "currentColor"
  })));
};
WarningSvg.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var icons = {
  bullet: BulletSvg,
  chevron_down: ChevronDownSvg,
  chevron_left: ChevronLeftSvg,
  chevron_right: ChevronRightSvg,
  chevron_up: ChevronUpSvg,
  close: CloseSvg,
  cross: CloseSvg,
  home: HomeSvg,
  information: InformationSvg,
  menu: MenuSvg,
  minus: MinusSvg,
  negative: NegativeSvg,
  padlock: PadlockSvg,
  plus: PlusSvg,
  positive: PositiveSvg,
  search: SearchSvg,
  tick: TickSvg,
  warning: WarningSvg
};
export default icons;